import {
  ASSIGNATED_ERRORS,
  GET_ASSIGNATED_ZONES,
  GET_ASSIGNATED_INSURED,
  GET_PRE_ASSIGNATED_RESPONSIBLE,
  GET_ASSIGNATED_ZONES_RESPONSABLE,
  GET_ASSIGNATED_RESPONSABLE_INSURED,
  POST_ASSIGNATED_RESPONSABLE,
  SELECT_ASSIGNATED_RESPONSABLE,
  CLEAN_STATE,
  GET_NOTIFICA_SINIESTRO
} from '../types'
import client from '../../lib/api-client'
import {
  API_ASSIGNATED_INSURED,
  API_ASSIGNATED_PRE_RESPONSIBLE,
  API_GESTION_CASES_RECEIVE,
  API_ASSIGNATED_ZONES_RESPONSABLE,
  API_ASSIGNATED_RESPONSIBLE
} from '../../lib/constants'

export const getCBZones = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_ASSIGNATED_ZONES,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getCBIsured = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_ASSIGNATED_INSURED}?q=${q}`)
    dispatch({
      type: GET_ASSIGNATED_INSURED,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getPreAssignedResponsible = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_ASSIGNATED_PRE_RESPONSIBLE}?q=${q}`)
    dispatch({
      type: GET_PRE_ASSIGNATED_RESPONSIBLE,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getZonesResponsable = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_ASSIGNATED_ZONES_RESPONSABLE}?q=${q}`)
    dispatch({
      type: GET_ASSIGNATED_ZONES_RESPONSABLE,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getResponsableInsured = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_ASSIGNATED_PRE_RESPONSIBLE}?q=${q}`)
    dispatch({
      type: GET_ASSIGNATED_RESPONSABLE_INSURED,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const postAssigantedResponsable = (body) => async (dispatch) => {
  try {
    const res = await client.post(`${API_ASSIGNATED_RESPONSIBLE}`, body)
    dispatch({
      type: POST_ASSIGNATED_RESPONSABLE,
      payload: res.data.message
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}

export const selectAsignated = (data) => async (dispatch) => {
  dispatch({
    type: SELECT_ASSIGNATED_RESPONSABLE,
    payload: data
  })
}

export const cleanStateAssignated = () => async (dispatch) => {
  dispatch({
    type: CLEAN_STATE,
    payload: []
  })
}
export const getCBNotificaSiniestro = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_NOTIFICA_SINIESTRO,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: ASSIGNATED_ERRORS,
      payload: console.log(e)
    })
  }
}